import { render, staticRenderFns } from "./AlertPersonalSet.vue?vue&type=template&id=6a64425d&scoped=true"
import script from "./AlertPersonalSet.vue?vue&type=script&lang=js"
export * from "./AlertPersonalSet.vue?vue&type=script&lang=js"
import style0 from "./AlertPersonalSet.vue?vue&type=style&index=0&id=6a64425d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64425d",
  null
  
)

export default component.exports